var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 36,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 21.0826C9.25 22.2406 9.8941 22.8587 11.0522 22.8587H20.9478C22.1124 22.8587 22.75 22.2406 22.75 21.0826V15.9168C22.75 14.7522 22.1124 14.1406 20.9478 14.1406H11.0522C9.8941 14.1406 9.25 14.7522 9.25 15.9168V21.0826ZM12.8739 19.43C12.3599 19.43 11.9435 19.0136 11.9435 18.4997C11.9435 17.9857 12.3599 17.5758 12.8739 17.5758C13.3878 17.5758 13.7977 17.9857 13.7977 18.4997C13.7977 19.0136 13.3878 19.43 12.8739 19.43ZM16.0098 19.43C15.4958 19.43 15.0794 19.0136 15.0794 18.4997C15.0794 17.9857 15.4958 17.5758 16.0098 17.5758C16.5172 17.5758 16.9336 17.9857 16.9336 18.4997C16.9336 19.0136 16.5172 19.43 16.0098 19.43ZM19.1457 19.43C18.6317 19.43 18.2153 19.0136 18.2153 18.4997C18.2153 17.9857 18.6317 17.5758 19.1457 17.5758C19.6531 17.5758 20.0695 17.9857 20.0695 18.4997C20.0695 19.0136 19.6531 19.43 19.1457 19.43Z",
    fill: "#F7685B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinC);
export default __webpack_public_path__ + "static/media/pin-c.7242cfd3de355ad55551b6411e1e0176.svg";
export { ForwardRef as ReactComponent };